import { atom, useAtom } from "jotai";
import { EmloyeesGroup, Emloyee } from "types";

export type EmployeesState = {
  activeGroupItem: EmloyeesGroup | null;
  activeItem: Emloyee | null;
};

type UseEmployeesStateReturn = {
  employeesState: EmployeesState;
  setEmployeesState: React.Dispatch<React.SetStateAction<EmployeesState>>;
};

export const employeesStateAtom = atom<EmployeesState>({
  activeGroupItem: null,
  activeItem: null,
});

export const useEmployeesState = (): UseEmployeesStateReturn => {
  const [employeesState, setEmployeesState] = useAtom(employeesStateAtom);

  return { employeesState, setEmployeesState };
};
